/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type EmailSignupInput = {
    readonly form?: EmailSignup | null;
    readonly clientMutationId?: string | null;
};
export type EmailSignup = {
    readonly formName?: string | null;
    readonly email?: string | null;
    readonly formFields?: EmailSignupFieldTypes | null;
};
export type EmailSignupFieldTypes = {
    readonly email?: FormInputObjectType | null;
};
export type FormInputObjectType = {
    readonly fieldLabel?: string | null;
    readonly fieldInput?: string | null;
    readonly componentType?: string | null;
    readonly validators?: ReadonlyArray<string | null> | null;
    readonly index?: number | null;
};
export type EmailSignupMutationVariables = {
    readonly input: EmailSignupInput;
};
export type EmailSignupMutationResponse = {
    readonly emailSignup: ({
        readonly success: boolean | null;
    }) | null;
};
export type EmailSignupMutation = {
    readonly response: EmailSignupMutationResponse;
    readonly variables: EmailSignupMutationVariables;
};



/*
mutation EmailSignupMutation(
  $input: EmailSignupInput!
) {
  emailSignup(input: $input) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "EmailSignupInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "emailSignup",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input",
                    "type": "EmailSignupInput!"
                }
            ],
            "concreteType": "EmailSignupPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "success",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "EmailSignupMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "EmailSignupMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "EmailSignupMutation",
            "id": null,
            "text": "mutation EmailSignupMutation(\n  $input: EmailSignupInput!\n) {\n  emailSignup(input: $input) {\n    success\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '23bdc4b1c41231665d8b411b1f2f1cab';
export default node;
